import { Observable } from 'rxjs';
import {
  ApiService,
  GET_LOCATION_GAMES_PATH,
  GET_NEARBY_GAMES_LIST_PATH,
  GET_NEARBY_GAMES_LOCATIONS_PATH,
  GetLocationGamesPathParams,
  GetLocationGamesResponse,
  GetNearbyGamesListResponse,
  GetNearbyGamesLocationsResponse
} from '@core-http';

export class NearbyGamesService extends ApiService {
  getMarkers(filters: string): Observable<GetNearbyGamesLocationsResponse> {
    return this.httpClient.get<GetNearbyGamesLocationsResponse>(
      `${this.env.apiUrl}${GET_NEARBY_GAMES_LOCATIONS_PATH}?${filters}`
    );
  }

  getGamesList(filters: string, showPrivate: boolean): Observable<GetNearbyGamesListResponse> {
    return this.httpClient.get<GetNearbyGamesListResponse>(
      `${this.env.apiUrl}${GET_NEARBY_GAMES_LIST_PATH}?${filters}&showPrivate=${showPrivate}`
    );
  }

  getLocationDetails(id: string): Observable<GetLocationGamesResponse> {
    const pathParams: GetLocationGamesPathParams = { locationId: id };
    const path: string = this.fillPathParams(GET_LOCATION_GAMES_PATH, pathParams);

    return this.httpClient.get<GetLocationGamesResponse>(`${this.env.apiUrl}${path}?showPrivateBlurred=true`);
  }
}
